<div>
  @if (!isEditing) {
    <span>
      @if (!pendingReviewOutcome) {
        <a (click)="toggleEdit()" class="add-date"> Select Outcome </a>
      }
      @if (!pendingReviewOutcome || pendingReviewOutcome === 'PEN') {
        <span>
          {{ pendingReviewOutcome }}
        </span>
      }
    </span>
  }
  <div
    class="editing"
    [ngClass]="{
      hidden: !isEditing
    }"
    >
    <form [formGroup]="form">
      <mat-button-toggle-group id="reviewOutcome" formControlName="reviewOutcome" name="reviewOutcome">
        <mat-button-toggle value="PEN">Pending</mat-button-toggle>
        <mat-button-toggle value="PRC">{{
          isModification ? 'Proceed to Modify' : 'Proceed to Reconsider'
        }}</mat-button-toggle>
        <mat-button-toggle value="REF">{{
          isModification ? 'Refuse to Modify' : 'Refuse to Reconsider'
        }}</mat-button-toggle>
      </mat-button-toggle-group>
    </form>
    <div class="button-container">
      <button mat-button (click)="toggleEdit()">CANCEL</button>
      <button mat-button class="save" (click)="onSave()">SAVE</button>
    </div>
  </div>
</div>
